var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "py-6" }, [
    _c("h3", { staticClass: "text-lg font-medium mb-3" }, [
      _vm._v("Step 7 of 9: Support Network"),
    ]),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 gap-3" },
      [
        _c("ValidationProvider", {
          attrs: { name: "Family Support" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Family Support "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "family_support",
                          placeholder: "Enter",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("family_support", val),
                        },
                        model: {
                          value: _vm.formData.family_support,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "family_support", $$v)
                          },
                          expression: "formData.family_support",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Social Connections" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Social Connections "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "social_connections",
                          placeholder: "Enter",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("social_connections", val),
                        },
                        model: {
                          value: _vm.formData.social_connections,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "social_connections", $$v)
                          },
                          expression: "formData.social_connections",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Community Resources" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Community Resources "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "community_resources",
                          placeholder: "Enter",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("community_resources", val),
                        },
                        model: {
                          value: _vm.formData.community_resources,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "community_resources", $$v)
                          },
                          expression: "formData.community_resources",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Professional Care Contacts" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: {
                        title: "Professional Care Contacts",
                        errors: errors,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Professional Care Contacts "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "professional_care_contacts",
                          placeholder: "Enter",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("professional_care_contacts", val),
                        },
                        model: {
                          value: _vm.formData.professional_care_contacts,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "professional_care_contacts",
                              $$v
                            )
                          },
                          expression: "formData.professional_care_contacts",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }